var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('dx-avatar',{attrs:{"name":_vm.avatar,"nickname":_vm.nickname}}),_vm._v(" "),_c('div',{staticClass:"dx-player__points"},[_vm._v("\n    "+_vm._s(_vm.points)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a91838","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DxPlayer.vue
// module id = null
// module chunks = 